export const isProduction = () => process.env.NODE_ENV === 'production';

export const isDevelopment = () => process.env.NODE_ENV === 'development';

export const isCaptchaEnabled = () => process.env.ENABLE_CAPTCHA === 'true';

// Check if stage is production (captcha enabled)
export const isStageProd = () => process.env.NEXT_PUBLIC_STAGE === 'prod';

// Check if stage is development (captcha disabled)
export const isStageDev = () => process.env.NEXT_PUBLIC_STAGE === 'dev';

// Check if captcha should be used (show UI and validate)
// Enabled on prod only; dev/other stages send mock fields.
export const shouldUseCaptcha = () => isStageProd();

// Get captcha fields - real data or mock data based on STAGE
export const getCaptchaFields = (realData?: { l?: string; c?: string; t?: string; g?: string }) => {
  if (shouldUseCaptcha() && realData) {
    return {
      l: realData.l,
      c: realData.c,
      t: realData.t,
      g: realData.g,
    };
  }
  // Return mock data for dev stage
  return {
    l: 'dev_mock_lot_number',
    c: 'dev_mock_captcha_output',
    t: 'dev_mock_pass_token',
    g: 'dev_mock_gen_time',
  };
};
